// extracted by mini-css-extract-plugin
module.exports = {"nolist":"withSetupNeeded__nolist--2-OxP"};